/**
 * Border Tokens (Internal Design System)
 *
 * Consistent border widths for the design system.
 */

export const borders = {
  width: {
    none: '0',
    thin: '0.0625rem',
    medium: '0.125rem',
    thick: '0.1875rem',
    handle: '0.25rem',
  },
} as const

export type Borders = typeof borders
